<template>
  <v-form @submit.prevent="save" novalidate>
    <pr-box :title="titleBox">

      <div slot="buttons-header">
        <v-btn icon @click.native="goToList">
          <v-icon color="white">list</v-icon>
        </v-btn>
      </div>

      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-subheader class="pl-0">{{ $t('views.fields.event.date') }}</v-subheader>
          <date-picker
            placeholder="Selecione a data"
            v-model="resource.date"
            :lang="lang"
            :editable="false"
            format="DD/MM/YYYY"
            clearable></date-picker>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-select
            :items="clients"
            item-text="name"
            item-value="id"
            hint="Vincular um cliente a este projeto"
            v-model="resource.client_id"
            required
            persistent-hint
            clearable
            @click:clear="reset"
            :disabled="disabledClient || (clients.length === 0)"
            no-data-text="Nenhuma registro encontrado"
            placeholder="Selecione um cliente"></v-select>
        </v-flex>
        <v-flex xs12 md6>
          <v-select
            :items="cycles"
            v-model="resource.cycle_id"
            item-text="name"
            item-value="id"
            required
            hint="Vincular um ciclo a este evento"
            :label="setLabelCycle()"
            persistent-hint
            :disabled="!resource.client_id || cycles.length === 0">
            <template slot="selection" slot-scope="data">
              {{ data.item.name }}
            </template>
            <template slot="item" slot-scope="data">
              <template>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ data.item.name }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-select
            :items="eventTypes"
            v-model="resource.event_type_id"
            item-text="description"
            item-value="id"
            required
            hint="Vincular um tipo a este evento"
            label="Selecione um tipo"
            persistent-hint
            :disabled="eventTypes.length === 0">
          </v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap mt-3>
        <v-flex xs12 md12>
          <quill-editor ref="description"
            v-model="resource.description"
            :options="editorOption">
          </quill-editor>
        </v-flex>
      </v-layout>

      <v-alert
        :value="showAlert || (resource.client_id && cycles.length === 0)"
        type="error">
        <span v-if="(clients.length === 0)">Não existem clientes cadastrados no sistema.</span>
        <span v-if="(clients.length > 0) && (cycles.length === 0)">
          Não existem ciclos cadastrados para o cliente selecionado.
        </span>
      </v-alert>

      <div slot="buttons-footer">
        <v-btn flat type="submit" color="primary" :disabled="(clients.length === 0) || (cycles.length === 0)" :loading="saveLoading">Salvar</v-btn>
      </div>
    </pr-box>
  </v-form>
</template>

<script>
import axios from 'axios';
import DatePicker from 'vue2-datepicker';
import CrudMixin from '@/components/mixins/CrudMixin';
import EventService from '@/features/event/EventService';
import ClientService from '@/features/client/ClientService';
import CycleService from '@/features/cycle/CycleService';
import EventTypeService from '@/features/event-type/EventTypeService';
import UserService from '@/features/user/UserService';

export default {
  name: 'project-form',
  mixins: [CrudMixin],
  components: { DatePicker },
  data() {
    return {
      showAlert: false,
      lang: 'pt-br',
      clients: [],
      cycles: [],
      eventTypes: [],
      editorOption: {
        placeholder: 'Descrição do chamado...',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ['link', 'video'],
          ],
        },
      },
      clientService: new ClientService(),
      cycleService: new CycleService(),
      eventTypeService: new EventTypeService(),
      disabledClient: false,
    };
  },
  watch: {
    clientId() {
      if (this.clientId) {
        const params = {
          client_id: this.clientId,
          active: 'sim',
        };
        this.cycleService.query(params).then((cycles) => {
          this.cycles = cycles;
        });
      }
    },
  },
  computed: {
    clientId() {
      return this.resource.client_id;
    },
  },
  created() {
    const user = this.$store.state.currentUser;
    if (!UserService.hasProfile(user, ['master', 'admin', 'analista'])) {
      this.resource.client_id = user.client.id;
      this.disabledClient = true;
    }
    this.loadCombos();
  },
  methods: {
    initCrud() {
      this.serviceType = EventService;
      this.routerName = 'event';
      this.componentType = 'FORM';
    },
    afterLoadResource() {
      if (!this.resource.date) this.resource.date = new Date();
    },
    setLabelCycle() {
      let label = 'Selecione um ciclo';
      if (!this.resource.client_id) {
        label = 'Nenhum cliente selecionado';
      } else if (this.resource.client_id && this.cycles.length === 0) {
        label = 'Nenhum ciclo cadastrado para este cliente';
      }
      return label;
    },
    reset() {
      this.resource.cycle_id = null;
    },
    loadCombos() {
      const requests = [
        this.eventTypeService.query(),
        this.clientService.query(),
      ];
      EventService.manyRequests(requests)
        .then(axios.spread((eventTypes, clients) => {
          this.eventTypes = eventTypes;
          this.clients = clients;
          if (this.clients.length === 0) {
            this.showAlert = true;
          }
        }));
    },
  },
};
</script>
<style>
  .quill-editor:not(.bubble) .ql-container,
  .quill-editor:not(.bubble) .ql-container .ql-editor {
    height: 15rem !important;
    padding-bottom: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/features/event/EventForm.vue